export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "StateSanitizeUtils.functional.worker.js?daef65466b1d6de88aaf");
}
